<template>
    <div class="browser">
        <div class="browser-header">
            <input
                v-model="url"
                type="text"
            >
        </div>
        <div class="browser-body">
            <iframe :src="src" />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                url: '',
                src: '',
            };
        },
        watch: {
            url() {
                if (this.timeout) {
                    clearInterval(this.timeout);
                }

                this.timeout = setInterval(this.updateSource, 250);
            },
        },
        methods: {
            updateSource() {
                this.src = this.url;
            },
        },
    };
</script>

<style lang="less">
    .browser {
        display: flex;
        width: calc(100% - 40px);
        height: calc(100vh - 40px);
        margin: 20px;

        flex-direction: column;

        border: 1px solid #d3dbe3;
        border-radius: 2px;
    }

    .browser-header {
        width: 100%;

        padding: 20px;
        flex: 0 0 auto;

        border-bottom: 1px solid #d3dbe3;

        input {
            width: 100%;

            font-size: 14px;

            padding: 5px;
        }
    }

    .browser-body {
        position: relative;

        flex: 1 1 auto;

        iframe {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            border: none;
        }
    }
</style>
